import Layout from "@/components/layouts/Layout"
import { revalidateTimeout } from "@/lib/constants";
import { SuscriptionForm } from "@/molecules";
import { getGlobalElements } from "@/utils/drupal/get-global-elements";
import { GetStaticPropsContext, GetStaticPropsResult } from "next";
import { NodePageProps } from "pages/[...slug]";

const Newsletter = ({
    theme,
    canonical,
    blocks,
    preFooter,
    meta
}: NodePageProps) => {
    const metas = [{ tag: "meta", attributes: { name: "title", content: "Newsletter" } },
    { tag: "meta", attributes: { name: "description", content: "Rellena tus datos para descargar tu EBOOK GRATUITO. Te enviaremos el libro a tu correo además de nuevas promociones, recetas y mucho más." } }];
    return (
        <Layout theme={theme ? 'dark' : 'light'} layoutType="base" canonical={canonical} blocks={blocks} preFooter={preFooter} meta={meta ? meta : metas}>
            <div className="u-wrapper w-full max-w-3xl flex flex-col justify-center gap-6 pt-[calc(var(--header-height)_+_20px)] pb-4 lg:pb-16 relative">
                <h1 className="text-headline text-headline--h2">Suscríbete a nuestra newsletter y consigue 10€ de descuento en tu primera compra.</h1>
                <p className="text-subtitle text-subtitle--l">Además tendrás acceso exclusivo a ofertas para miembros.</p>
                <SuscriptionForm
                    backgroundColor="inherit"
                    title=""
                    textButton="ACEPTAR"
                    nameLabel="Nombre"
                    lastNameLabel="Apellidos"
                    emailLabel="Email"
                    defaultEmail=""
                />
            </div>
        </Layout>
    );
};
export default Newsletter;

export async function getStaticProps(context: GetStaticPropsContext): Promise<GetStaticPropsResult<NodePageProps>> {

    const slug = "/es/newsletter";
    return {
        props: {
            ...(await getGlobalElements(context)),
            content: null,
            theme: null,
            preFooter: true,
            meta: null,
            canonical: slug
        },
        revalidate: revalidateTimeout
    };
}